import { Box } from "@mui/material";
import React from "react";

interface SubNavBarProps {
  children?: React.ReactNode;
  className?: string;
}

/**
 * Styled Sub Navigation that goes below the header.
 */
export function SubNavBar({ children, className }: SubNavBarProps) {
  const defaultClassName =
    "bg-axon-light h-[50px] text-white flex px-[10px] sm:px-[20px] md:px-[30px] items-center space-x-2";
  const finalClassName = className ? `${defaultClassName} ${className}` : defaultClassName;
  return <Box className={finalClassName}>{children}</Box>;
};
